export default __webpack_public_path__ + "static/media/BannerImg.81f3919a.png";